import { Injectable } from '@angular/core';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './portal-invite.actions';
import {
	PortalInvite,
	PortalInvitee,
	PortalInviteStatus,
} from '@models/portal-invites';

@Injectable({
	providedIn: 'root',
})
export class PortalInviteDispatch {
	@Dispatch()
	CreatePortalInvite = (payload: { portalInvite: PortalInvite }) =>
		new actions.CreatePortalInvite(payload);

	@Dispatch()
	AddInvitees = (payload: { inviteId: string; invitees: PortalInvitee[] }) =>
		new actions.AddInvitees(payload);

	@Dispatch()
	RemoveInvitees = (payload: { inviteId: string; invitees: PortalInvitee[] }) =>
		new actions.RemoveInvitees(payload);

	@Dispatch()
	UpdateInviteeEmail = (payload: {
		inviteId: string;
		newEmail: string;
		clientId: string;
	}) => new actions.UpdateInviteeEmail(payload);

	@Dispatch()
	UpdateStatus = (payload: {
		inviteId: string;
		status: PortalInviteStatus;
		updatedBy: string;
	}) => new actions.UpdateStatus(payload);

	@Dispatch()
	DeactivatePortalInvite = (payload: { inviteId: string; updatedBy: string }) =>
		new actions.DeactivatePortalInvite(payload);
}
